import { IsOptional, IsString } from 'class-validator';
import { BaseDto } from './base.dto';

export class BidNotesPool extends BaseDto {
  @IsString()
  name?: string;

  @IsString()
  @IsOptional({ always: true })
  content?: string;
}
